export const getAccount = (slug, successCallback) => {
  fetch(`/api/v2/accounts/${slug}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const getAccounts = (successCallback) => {
  fetch(`/api/v2/accounts`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};
